import { useExecutionDataView } from "@gooddata/sdk-ui";
import { Modal, Select } from "antd";
import React from "react";
import { utils, writeFile } from "xlsx";
import * as Md from "../../md/full";
import { useEffect } from "react";
import { useState } from "react";
import { useBasketContext } from "../../contexts/BasketProvider";
import LoadingSpinner from "../LoadingSpinner";
const exportFile = (data) => {
    const ws = utils.json_to_sheet(data);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");
    writeFile(wb, "oem_offers.xlsx");
};

const Export = ({ modalVisible, setModalVisible, seriesBy, data, filters, countryId }) => {
    const [durations, setDurations] = useState([]);
    const [selectedDurations, setSelectedDurations] = useState([]);
    const { userBaskets, systemBaskets, selectedBasketFilters } = useBasketContext();
    const [exportData, setExportData] = useState([]);

    const { result, status, error } = useExecutionDataView({
        execution: {
            seriesBy: [...seriesBy, Md.Doors.Avg, Md.Apr.Avg],
            slicesBy: [Md.VersionStd, Md.CorrMake, Md.Fuel, Md.Channel3, Md.Duration, Md.CorrModel, Md.VehSegment, Md.BodyStyle, Md.TrimName, Md.Version, Md.GearsPlus],
            filters: filters,
        },
    });

    const transformedUserBaskets =
        selectedBasketFilters !== undefined
            ? userBaskets
                  .filter((basket) => selectedBasketFilters?.includes(basket))
                  .map((basket) => {
                      return {
                          name: basket.name,
                          vehicles: basket.basketFilters.map((filter) => {
                              return filter.value;
                          }),
                      };
                  })
            : userBaskets.map((basket) => {
                  return {
                      name: basket.name,
                      vehicles: basket.basketFilters.map((filter) => {
                          return filter.value;
                      }),
                  };
              });
    const transformedSystemBaskets =
        selectedBasketFilters !== undefined
            ? systemBaskets
                  .filter((basket) => selectedBasketFilters?.includes(basket))
                  .map((basket) => {
                      return {
                          name: basket.name,
                          vehicles: basket.basketFilters.map((filter) => {
                              return filter.value;
                          }),
                      };
                  })
            : systemBaskets.map((basket) => {
                  return {
                      name: basket.name,
                      vehicles: basket.basketFilters.map((filter) => {
                          return filter.value;
                      }),
                  };
              });
    const basketList = [...transformedUserBaskets, ...transformedSystemBaskets];

    useEffect(() => {
        const slices = result?.data()?.slices().toArray();
        if (slices?.length > 0) {
            const flat = slices?.map((slice) => {
                return {
                    Duration: slice.sliceTitles()[4],
                };
            });
            setDurations(flat?.map((d) => d.Duration)?.filter((v, i, a) => a.indexOf(v) === i));
        }
    }, [result]);

    useEffect(() => {
        const slices = result?.data()?.slices().toArray();
        if (slices?.length > 0) {
            const raw = slices?.map((slice) => {
                return {
                    Vehicle: slice.sliceTitles()[0],
                    Duration: slice.sliceTitles()[4],
                    Adj_Rental: Number(slice.dataPoints()[23].rawValue).toFixed(0),
                    Leasing_Factor: (100 * Number(slice.dataPoints()[24].rawValue)).toFixed(2),
                };
            });
            const filtred = selectedDurations?.map((d) => {
                return raw?.filter((r) => r.Duration === d);
            });

            const adjusted = filtred?.map((e) => {
                return e?.map((ee) => {
                    return {
                        Vehicle: ee.Vehicle,
                        ["Adj_Rental ".concat(`(${ee.Duration})`)]: Number(ee["Adj_Rental"]),
                        ["Leasing_Factor ".concat(`(${ee.Duration})`)]: Number(ee["Leasing_Factor"]),
                    };
                });
            });
            const part1 = data?.map((d) => {
                const baseData = {
                    Vehicle: d.Vehicle,
                    List_Price: Number(d["List_Price"]) > 0 ? Number(d["List_Price"]) : null,
                    Channel: d.Channel,
                    Finance_Type: d["Finance_Type"],
                    Months: Number(d.Months),
                    Mileage: Number(d.Mileage),
                    Web_Rental: Number(d["Web_Rental"]) > 0 ? Number(d["Web_Rental"]) : null,
                    Web_Deposit: Number(d.Web_Deposit) > 0 ? Number(d.Web_Deposit) : 0,
                };

                // Handle Interest Rate field based on country
                if (countryId === "IT") {
                    baseData.TAEG = d["Interest_Rate"] || d["TAEG"];
                    baseData.Discount = d["discount"];
                    baseData["Purchase_Price"] = d["invest"];
                    if (d.TAN !== undefined) {
                        baseData.TAN = d.TAN;
                    }
                } else {
                    baseData.Interest_Rate = d["Interest_Rate"];
                }

                return {
                    ...baseData,
                    RV: Number(d.RV) > 0 ? Number(d.RV) : null,
                    Web_Rental_Includes: d["Web_Rental_Includes"],
                };
            });

            const part2 = data?.map((d) => {
                const baskets = basketList
                    .filter((basket) => {
                        return basket.vehicles.includes(d.Vehicle);
                    })
                    .map((basket) => {
                        return basket.name;
                    })
                    ?.filter((item, index, self) => {
                        return index === self.indexOf(item);
                    })
                    .join(", ");
                return {
                    Vehicle: d.Vehicle,
                    Adj_Rental_Includes: d["Adj_Rental_Includes"],
                    Make: d.Make,
                    Model: d.Model,
                    Energy: d.Energy,
                    Trim: d.Trim,
                    Vehicle_Segment: d.Vehicle_Segment,
                    Body_Type: d.Body_Type,
                    Gearbox: d.Gearbox,
                    Doors: Number(d.Doors) > 0 ? Number(d.Doors) : null,
                    Power: Number(d.Power) > 0 ? Number(d.Power) : null,
                    Drive: d.Drive,
                    Version: d.Version,
                    Comment: d.Comment,
                    Baskets: baskets,
                    Url: d.Url,
                };
            });

            const toExport = part1?.map((p1, i) => {
                adjusted.forEach((a) => {
                    a.forEach((aa) => {
                        if (p1.Vehicle === aa.Vehicle) {
                            p1 = { ...p1, ...aa };
                        }
                    });
                });
                return p1;
            });

            const header = toExport
                ?.map((e) => {
                    return Object.keys(e);
                })
                .flat();
            const uniqueHeader = header?.filter((v, i, a) => a.indexOf(v) === i);
            const tobeExported = toExport?.map((e, i) => {
                const obj = {};
                uniqueHeader?.forEach((h) => {
                    obj[h] = e[h];
                });
                return { ...obj, ...part2[i] };
            });

            if (selectedDurations?.length > 0) {
                setExportData(tobeExported);
            } else {
                let Exported = data?.map((d) => {
                    const baskets = basketList
                        .filter((basket) => {
                            return basket.vehicles.includes(d.Vehicle);
                        })
                        .map((basket) => {
                            return basket.name;
                        })
                        ?.filter((item, index, self) => {
                            return index === self.indexOf(item);
                        })
                        .join(", ");
                    const baseExportData = {
                        Vehicle: d.Vehicle,
                        List_Price: Number(d["List_Price"]) > 0 ? Number(d["List_Price"]) : null,
                        Channel: d.Channel,
                        Finance_Type: d["Finance_Type"],
                        Months: Number(d.Months),
                        Mileage: Number(d.Mileage),
                        Web_Rental: Number(d["Web_Rental"]) > 0 ? Number(d["Web_Rental"]) : null,
                        Web_Deposit: Number(d.Web_Deposit) > 0 ? Number(d.Web_Deposit) : 0,
                    };

                    // Handle Interest Rate field based on country for export data
                    if (countryId === "IT") {
                        baseExportData.TAEG = d["Interest_Rate"] || d["TAEG"];
                        if (d.TAN !== undefined) {
                            baseExportData.TAN = d.TAN;
                        }
                    } else {
                        baseExportData.Interest_Rate = d["Interest_Rate"];
                    }

                    return {
                        ...baseExportData,
                        RV: Number(d.RV) > 0 ? Number(d.RV) : null,
                        Web_Rental_Includes: d["Web_Rental_Includes"],
                        Adj_Rental: Number(d["Adj_Rental"]) > 0 ? Number(d["Adj_Rental"]) : null,
                        Leasing_Factor: Number(d["Leasing_Factor"]) > 0 ? Number(d["Leasing_Factor"]) : null,
                        Adj_Rental_Includes: d["Adj_Rental_Includes"],
                        Make: d.Make,
                        Model: d.Model,
                        Energy: d.Energy,
                        Trim: d.Trim,
                        Vehicle_Segment: d.Vehicle_Segment,
                        Body_Type: d.Body_Type,
                        Gearbox: d.Gearbox,
                        Doors: Number(d.Doors) > 0 ? Number(d.Doors) : null,
                        Power: Number(d.Power) > 0 ? Number(d.Power) : null,
                        Drive: d.Drive,
                        Version: d.Version,
                        Baskets: baskets,
                        Comment: d.Comment,
                        Url: d.Url,
                    };
                });
                setExportData(Exported);
            }
        }
    }, [result, selectedDurations, data, countryId]);

    return (
        <Modal
            open={modalVisible}
            title={"Export"}
            onOk={() => {
                exportData && exportFile(exportData);
                setModalVisible(false);
            }}
            onCancel={() => setModalVisible(false)}
        >
            {status === "success" && (
                <>
                    <p>Select Extrapolation Durations :</p>
                    <Select
                        mode={"multiple"}
                        style={{ width: 400 }}
                        placeholder="Select Your Durations"
                        onChange={(value) => {
                            setSelectedDurations(value);
                        }}
                    >
                        {durations?.map((d) => {
                            return (
                                <Select.Option key={d} value={d}>
                                    {d}
                                </Select.Option>
                            );
                        })}
                    </Select>
                </>
            )}
            {status === "loading" && <LoadingSpinner />}
            {status === "error" && (
                <div>
                    <p>Error</p>
                    <span>{error.message}</span>
                </div>
            )}
        </Modal>
    );
};

export default Export;
